import { render, staticRenderFns } from "./menu-item.vue?vue&type=template&id=47eb4a0e&scoped=true"
import script from "./menu-item.vue?vue&type=script&lang=js"
export * from "./menu-item.vue?vue&type=script&lang=js"
import style1 from "./menu-item.vue?vue&type=style&index=1&id=47eb4a0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47eb4a0e",
  null
  
)

export default component.exports